import SearchComp from "../../common/searchcomp";
import { Button as MuiButton } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

export const PedidosSearchView = (
    {
        constantes,
        getPedidos,
        permiteVisualizar,
        loading
    }) => {

    const columnsFilter = [
        {
            field: "Id",
            headerName: constantes.Numero,
            tipo: "number",
        },
        {
            field: "DataCadastro",
            headerName: constantes.DataCadastro,
            tipo: "date",
            format: 'dd/MM/yyyyy'
        },
        {
            field: "ClienteId",
            headerName: constantes.CodigoCliente,
            tipo: "number",
        },
        {
            field: "ClienteNome",
            headerName: constantes.Cliente,
            tipo: "text",
        },
        {
            field: "ObservacaoUsuario",
            headerName: constantes.ObservacaoUsuario,
            tipo: "text",
        },
        {
            field: "OrcamentoId",
            headerName: constantes.OrcamentoDeVenda,
            tipo: "number",
        },
    ];

    function onSearchTitle(searchValue, searchField, serachFilter) {
        let filter = {
            situacao: null,
            campo: searchField,
            operacao: serachFilter,
            valor: searchValue,
        };
        getPedidos(filter);
    }

    return permiteVisualizar &&
            <SearchComp
                botaoDisabilitado={loading}
                title={constantes.PedidoVendas}
                campos={columnsFilter}
                onSearch={(values) => {
                    onSearchTitle(
                        values.searchValue,
                        values.searchField,
                        values.searchoperator
                    );
                }}
                renderButton={({ disabled }) => (
                    <MuiButton
                        type="submit"
                        fullWidth
                        disabled={disabled}
                        startIcon={<SearchIcon />}
                        sx={{
                            backgroundColor: "#009180",
                            color: "white",
                            fontWeight: "bold",
                            textTransform: "none",
                            fontSize: "0.875rem",
                            height: "2.3rem",
                            borderRadius: "5px",
                            "&:hover": { backgroundColor: "#006e62" },
                            "&.Mui-disabled": { backgroundColor: "#ccc", color: "#666" },
                        }}
                    >
                        {constantes.Buscar}
                    </MuiButton>
                )}
            />

}
